export default function (params) {
    if (params.hexToBeSign) {
        console.error('getSignature: hexToBeSign is deprecated, please use signInfo instead, signInfo is utf-8 string not hex');
    }
}
